import {
    Component,
    AfterViewInit,
    ViewChild,
    ElementRef,
    OnDestroy,
    EventEmitter
} from '@angular/core';
import Expand from '@arcgis/core/widgets/Expand';
import LayerList from '@arcgis/core/widgets/LayerList';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import TileLayer from '@arcgis/core/layers/TileLayer';
import { MapService } from '../../services/map.service';
import { EnvironmentService } from '../../services/environment.service';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import ListItem from '@arcgis/core/widgets/LayerList/ListItem';
import Collection from '@arcgis/core/core/Collection';
import { async } from 'rxjs/internal/scheduler/async';
import Slider from '@arcgis/core/widgets/Slider';
import Legend from '@arcgis/core/widgets/Legend';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import Search from '@arcgis/core/widgets/Search';
import LayerSearchSource from '@arcgis/core/widgets/Search/LayerSearchSource';
// import Query from "@arcgis/core/rest/support/Query";
// import AttachmentQuery from '@arcgis/core/rest/support/AttachmentQuery.js';
import IdentifyParameters from '@arcgis/core/rest/support/IdentifyParameters';
import * as identify from '@arcgis/core/rest/identify';
// import { whenTrueOnce } from '@arcgis/core/core/whenTrue';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
// import * as pdfjsLib from 'pdfjs-dist';
import CustomContent from '@arcgis/core/popup/content/CustomContent.js';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class MapComponent implements AfterViewInit, OnDestroy {
    @ViewChild('mapView', { static: false })
    mapElementRef?: ElementRef;
    private layerList: LayerList;

    private prevExtent = false;
    private preExtent: __esri.Extent | null = null;
    private currentExtent: __esri.Extent | null = null;
    private extentHistory = [];

    private extentHistoryIndx = 0;
    private nextExtent = false;
    l_zoomPrevBtn = document.getElementById('zoomPrevBtn');
    l_zoomNextBtn = document.getElementById('zoomNextBtn');

    // public layerLabels = {
    //   "PARCEL_Amana20211219": ["اسم المخطط", "رقم المخطط", "رقم القطعة"],
    //   "PAR_Boundry_zone_New": ["اسم المخطط باللغة العربية", "رقم مميز المخطط التقسيمي", "نوع المخطط", "تصحيح قطع المخطط", "تصحيح قطع الاراضي", "المراجعة1", "المرحلة"],
    //   "STREET_Amana20211219": ["NAME_ARABI", "NO"]

    //   // Add more mappings for other layers...
    //  };

    constructor(
        readonly environment: EnvironmentService,
        readonly mapService: MapService
    ) { }

    ngAfterViewInit(): void {
        this.mapService.initDefaultMap(this.mapElementRef);

        this.mapService.addAllMapWidgets();

        // let node = document.createElement("div");
        // node.innerHTML = "I'm a real node!";

        let node = document.getElementById('ctr');

        let expand = new Expand({
            expandIconClass: 'esri-icon-right-arrow',
            view: this.mapService.mapView,
            content: node
        });

        //hide expand sequential search
        this.mapService.mapView?.ui.add(expand, 'bottom-right');

        //-----------------------------------

        // const layerUrl = 'http://192.168.1.106:6080/arcgis/rest/services/amanaTest/amanaTest/MapServer';

        // const sublayerTitles = [
        //   "طبقة البلدية",
        //   "طبقة استخدام الأرض",
        //   "طبقة المخططات",
        //   "طبقة الأراضي"
        // ];

        // let layer = new MapImageLayer({
        //   url: layerUrl,
        //   sublayers: [
        //     {
        //       id: 3,
        //       title: sublayerTitles[0]
        //     },
        //     {
        //       id: 2,
        //       title: sublayerTitles[1]
        //     },
        //     {
        //       id: 1,
        //       title: sublayerTitles[2]
        //     },
        //     {
        //       id: 0,
        //       title: sublayerTitles[3]
        //     }

        //   ]
        // });

        // layer.load().then(() => {
        //   this.mapService.map.layers.add(layer);
        // });
        this.mapService.configureMapLayer();

        // this.mapService.mapView.when(()=>{
        //   let esriZoom= document.getElementsByClassName("esri-zoom");
        //   let mov= document.getElementsByClassName("mov");
        //   debugger;
        //   for(let i=0 ; i< mov.length-1; i++){

        //     esriZoom[0].appendChild(mov[i]);
        //   }

        // })

        reactiveUtils.when(
            () => this.mapService.mapView.stationary === true,
            () => {
                this.extentChangeHandler(this.mapService.mapView.extent);
            }
        );

        // layer List

        this.layerList = new LayerList({
            id: 'layerList',
            view: this.mapService.mapView,
            listItemCreatedFunction: async (event) => {
                const item = event.item;
                await item.layer.when();

                item.actionsSections = [
                    [
                        {
                            title: 'Increase opacity',
                            className: 'esri-icon-up',
                            id: 'increase-opacity' //'change-opacity'
                        },
                        {
                            title: 'Decrease opacity',
                            className: 'esri-icon-down',
                            id: 'decrease-opacity'
                        }
                    ]
                ];
                // Adds a slider for updating a group layer's opacity

                // if (item.children.length > 1 && item.parent) {

                // Create a Legend widget
                const legend = new Legend({
                    view: this.mapService.mapView,
                    layerInfos: [
                        {
                            layer: item.layer,
                            title: item.layer.title
                        }
                    ]
                });

                const slider = new Slider({
                    min: 0,
                    max: 1,
                    precision: 2,
                    values: [1],
                    visibleElements: {
                        labels: true,
                        rangeLabels: true
                    }
                });

                item.panel = {
                    content: [legend, slider],
                    className: 'esri-icon-sliders-horizontal',
                    title: 'Change layer opacity'
                };

                slider.on('thumb-drag', (event) => {
                    const { value } = event;
                    item.layer.opacity = value;
                });
                // }
            }
        });

        this.layerList.on('trigger-action', (event) => {
            const id = event.action.id;
            const layr = event.item.layer;
            // const visibleLayer =layr.visible;

            if (id === 'increase-opacity') {
                // if the increase-opacity action is triggered, then
                // increase the opacity of the GroupLayer by 0.25

                if (layr.opacity < 1) {
                    layr.opacity += 0.25;
                }
            } else if (id === 'decrease-opacity') {
                // if the decrease-opacity action is triggered, then
                // decrease the opacity of the GroupLayer by 0.25

                if (layr.opacity > 0) {
                    layr.opacity -= 0.25;
                }
            }
        });
        //hide layer list
        this.mapService.mapView.ui.add(this.layerList, 'top-left');

        const streetsLayer = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/0',
            title: ' طبقة الشوارع '
        });

        const parcelLayer = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2',
            title: ' طبقة الأراضي المصححة '
        });
        const PARBoundryLayerNew = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5',
            title: ' طبقة المخططات '
            // visible: false
        });

        // const zonesLayer = new FeatureLayer({
        //   url: "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/6",
        //   // title: " طبقة النطاقات ",
        //   // visible: false
        // });

        // const belediyeLayer = new FeatureLayer({
        //   url: "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/7",
        //   // title: " طبقة البلدية ",
        //   // visible: false
        // });

        let parcelLayerSource = new LayerSearchSource({
            layer: parcelLayer,
            searchFields: ['PARCEL_ID'], // رقم مميز قطعة الأرض
            displayField: 'SUBDIVISIONPLANNAME_AR', // الاسم بالعربية
            // exactMatch: false,
            outFields: ['*'],
            name: 'قطع الأراضي',
            placeholder: 'example: 1-299087'
        });

        let PARBoundryNewLayerSource = new LayerSearchSource({
            layer: PARBoundryLayerNew,
            searchFields: ['SUBDIVISIONPLAN_ID', 'SUBDIVISIONNAME_AR'],
            displayField: 'SUBDIVISIONNAME_AR',
            suggestionTemplate:
                '{SUBDIVISIONPLAN_ID}, PLAN NAME: N{SUBDIVISIONNAME_AR}',
            // exactMatch: false,
            outFields: ['*'],
            placeholder: 'example: 875\\ت\\1420 or سليمان حامد الاحمدى ',
            name: 'المخططات'
            // zoomScale: 500000,
        });
        PARBoundryLayerNew['defaultQueryFeatures'] =
            PARBoundryLayerNew.queryFeatures;
        PARBoundryLayerNew.queryFeatures = function (
            query: __esri.QueryProperties
        ) {
            if (query && typeof query.where == 'string') {
                query.where = query.where.replace(/ LIKE '/g, " LIKE N'%");
            }
            return PARBoundryLayerNew.get<Function>(
                'defaultQueryFeatures'
            ).apply(this, arguments);
        };

        let search = new Search({
            view: this.mapService.mapView,
            allPlaceholder: 'البحث في جميع الطبقات',
            includeDefaultSources: false,
            sources: [parcelLayerSource, PARBoundryNewLayerSource] //, PARBoundryLayerSource
        });
        // hide search
        this.mapService.mapView.ui.add(search, 'manual');

        //identify

        // executeIdentify() is called each time the view is clicked
        this.mapService.mapView.on('click', (event) => {
            this.executeIdentify(event);
        });

        //-------------------------
    } // End Of ng After View Init //

    panToHand() {
        // this.mapService.mapView?.goTo({ center: this.mapService.mapView.center });
    }

    // Return to the main zoom of the map
    zoomToHome() {
        if (this.mapService.mapView) {
            this.mapService.mapView.goTo({
                center: [
                    this.environment.baseConfigs.defaultMapSettings.centerLon,
                    this.environment.baseConfigs.defaultMapSettings.centerLat
                ],
                zoom: this.environment.baseConfigs.defaultMapSettings.zoomLevel
            });
        }
    }

    zoomToNextExtent(): void {
        this.nextExtent = true;
        this.extentHistoryIndx++;
        if (this.extentHistoryIndx > this.extentHistory.length - 1) {
            this.extentHistoryIndx = this.extentHistory.length - 1;
        }
        this.mapService.mapView.goTo(
            this.extentHistory[this.extentHistoryIndx].currentExtent
        );
    }

    zoomToPreviousExtent(): void {
        if (this.extentHistory[this.extentHistoryIndx].preExtent) {
            this.prevExtent = true;
            this.mapService.mapView.goTo(
                this.extentHistory[this.extentHistoryIndx].preExtent
            );
            this.extentHistoryIndx--;
        }
    }

    extentChangeHandler(evt) {
        if (this.prevExtent || this.nextExtent) {
            this.currentExtent = evt;
        } else {
            this.preExtent = this.currentExtent;
            this.currentExtent = evt;
            this.extentHistory.push({
                preExtent: this.preExtent,
                currentExtent: this.currentExtent
            });
            this.extentHistoryIndx = this.extentHistory.length - 1;
        }
        this.prevExtent = this.nextExtent = false;
        // this.extentHistoryChange();
    }

    // extentHistoryChange() {
    //   if (this.extentHistory.length === 0 || this.extentHistoryIndx === 0) {
    //     this.l_zoomPrevBtn.classList.add('esri-disabled');
    //   } else {
    //     this.l_zoomPrevBtn.classList.remove('esri-disabled');
    //   }
    //   if (this.extentHistory.length === 0 || this.extentHistoryIndx === this.extentHistory.length - 1) {
    //     this.l_zoomNextBtn.classList.add('esri-disabled');
    //   }else {
    //     this.l_zoomNextBtn.classList.remove('esri-disabled');
    //   }
    // }

    ngOnDestroy(): void {
        if (this.mapService.mapView) {
            this.mapService.mapView.destroy();
            // this.unsubscribeFromSearchService();
        }
    }
    executeIdentify(event) {
        if (true) {
            console.log(event);
            console.log(this);

            // Set the parameters for the identify
            let params = new IdentifyParameters();
            params.tolerance = 3;
            params.layerIds = [0, 1, 2, 4, 5, 6, 7];
            params.layerOption = 'all';
            params.width = this.mapService.mapView.width;
            params.height = this.mapService.mapView.height;
            // Set the geometry to the location of the view click
            params.geometry = event.mapPoint;
            params.mapExtent = this.mapService.mapView.extent;
            // let mv= document.getElementsByClassName("mapView") as any;
            // console.log( mv[0]);
            // mv[0].style.cursor = "wait";

            // This function returns a promise that resolves to an array of features
            // A custom popupTemplate is set for each feature based on the layer it
            // originates from

            //----------------tested identify
            // identify
            // .identify(this.mapService.layerUrl, params)
            // .then( (response)=> {
            //  const results = response.results;

            //  return results.map( (result)=> {
            //     let feature = result.feature;
            //     let layerName = result.layerName;

            //     feature.attributes.layerName = layerName;
            //     console.log("layerName=" + layerName);
            //     console.log(feature);

            //     // Call createForm for each layer
            //     if (this.layerLabels.hasOwnProperty(layerName)) {
            //       this.createForm(feature, layerName);
            //     }

            //     return feature;
            //  });
            // })
            // .then((response) => {
            //  // Send the array of features to showPopup()
            //  this.showPopup(response, event);
            // });

            //----------------tested identify

            //----------------------------------main before test
            identify
                .identify(this.mapService.layerUrl, params)
                .then(function (response) {
                    const results = response.results;

                    return results.map(function (result) {
                        let feature = result.feature;
                        let layerName = result.layerName;

                        feature.attributes.layerName = layerName;
                        console.log('layerName=' + layerName);
                        console.log(feature);
                        if (
                            layerName ===
                            'PlanCorrectionDB.DBO.CorrectedParcels'
                        ) {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة قطع الأراضي',
                                content:
                                    '<b>اسم المخطط التقسيمي:</b> {الاسم بالعربية} ' +
                                    '<br><b>رقم مميز المخطط التقسيمي:</b> {رقم مميز المخطط التقسيمي}' +
                                    '<br><b>رقم مميز قطعة الأرض:</b> {رقم مميز قطعة الأرض}' +
                                    "<br><b>رخصة الإنشاء:</b><img src='https://support.content.office.net/ar-sa/media/f44322e0-367e-415d-ac2b-0c44e2e7c959.jpg' alt='رخصة انشاء'/>"
                                // "<br><button onclick='openPdf(\"path_to_your_pdf.pdf\")'>Open PDF</button>",
                            };
                        } else if (layerName === 'STREET_Amana') {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة الشوارع',
                                content:
                                    '<b>الإسم:</b> {NAME_ARABI} ' +
                                    '<br><b>الرقم:</b> {NO}' //+
                                // "<br><b>تحديث أعمال التنفيذ: </b> {تحديث_اعمال_التن}"
                            };
                        }
                        //             else if (layerName === "PAR_Boundry_zone") {
                        //               feature.popupTemplate = {
                        //                 // autocasts as new PopupTemplate()
                        //                 title: "طبقة المخططات القديمة", //"{LABEL_LOCAL}",
                        //                 content:
                        //                   "<b>اسم المخطط باللغة العربية:</b> {SUBDIVISIONNAME_AR} " +
                        //                   "<br><b>رقم مميز المخطط التقسيمي:</b> {SUBDIVISIONPLAN_ID}" +
                        //                   "<br><b>نوع المخطط:</b> {AMANAPLANTYPE}",
                        //               };

                        // // //-----------test
                        // //             feature.popupTemplate = {
                        // //               // autocasts as new PopupTemplate()
                        // //               title: "طبقة قطع الأراضي",
                        // //               content: new CustomContent({
                        // //                 outFields: ["*"],
                        // //                 creator: function () {
                        // //                   const div = document.createElement("div");
                        // //                   const graphic = this.graphic; // Access the graphic from 'this'
                        // //       console.log(graphic);
                        // //                   const planName = graphic.attributes.PLAN_NAME || "";
                        // //                   const planNo = graphic.attributes.PLAN_NO || "";
                        // //                   const parcelNo = graphic.attributes.PARCELNO || "";
                        // //                   const license = graphic.attributes.LICENSE || "";

                        // //                   div.innerHTML = `
                        // //                     <b>اسم المخطط:</b> <input type="text" id="planNameInput" value="${planName}">
                        // //                     <br><b>رقم المخطط:</b> <input type="text" id="planNoInput" value="${planNo}">
                        // //                     <br><b>رقم القطعة:</b> <input type="text" id="parcelNoInput" value="${parcelNo}">
                        // //                     <br><b>رخصة الإنشاء:</b> <input type="text" id="licenseInput" value="${license}">
                        // //                   `;

                        // //                   return div;
                        // //                 }
                        // //               })
                        // //             };

                        //             }
                        else if (
                            layerName === 'PlanCorrectionDB.DBO.Finall_plans'
                        ) {
                            //       // debugger;

                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة المخططات', //"{LABEL_LOCAL}",
                                content:
                                    //         `
                                    //   <b>اسم المخطط باللغة العربية:</b> <input type="text" id="arabicPlanNameInput" value="${feature.attributes['اسم المخطط باللغة العربية']}"/>
                                    //   <br><b>رقم مميز المخطط التقسيمي :</b> <input type="text" id="divisionPlanNoInput" value="${feature.attributes['رقم مميز المخطط التقسيمي']}"/>
                                    //   <br><b>نوع المخطط:</b> <input type="text" id="planTypeInput" value="${feature.attributes['نوع المخطط']}"/>
                                    //   <br><b>تصحيح قطع المخطط :</b> <input type="text" id="planCorrectionInput" value="${feature.attributes['تصحيح_قطع_المخطط']}"/>
                                    //   <br><b>تصحيح قطع الاراضي :</b> <input type="text" id="landCorrectionInput" value="${feature.attributes['تصحيح_قطع_الاراضي']}"/>
                                    //   <br><b>المراجعة1:</b> <input type="text" id="qcReviewInput" value="${feature.attributes['المراجعة_QC_R!']}"/>
                                    //   <br><b>المرحلة:</b> <input type="text" id="stageInput" value="${feature.attributes['المرحلة']}"/>
                                    // `
                                    '<b>اسم المخطط :</b> {اسم المخطط} ' +
                                    '<br><b>رقم مميز المخطط :</b> {رقم مميز المخطط}' +
                                    '<br><b>نوع المخطط:</b> {نوع المخطط}' +
                                    '<br><b> عدد قطع الأراضي : </b> {عدد قطع الاراضي بالمخطط}' +
                                    '<br><b>تقسيم مناطق التصوير الجوي:</b> {تقسيم مناطق التصوير الجوي}' +
                                    // "<br><b>الحالة:</b> {Status}"+
                                    '<br><b>مرحلة تصحيح المخطط :</b> {مرحلة تصحيح المخطط}' +
                                    '<br><b>اسم الحي:</b> {اسم الحي}'
                            };
                            //--------------------------
                            //   feature.popupTemplate = {
                            //     title: "طبقة المخططات",
                            //     content: function(feature){
                            //         // Create a div to hold the form
                            //         let div = document.createElement('div');

                            //         // Create the form
                            //         let form = document.createElement('form');
                            //         form.id = "myForm";
                            //         div.appendChild(form);

                            //         // Create the input fields
                            //         let fields = ['اسم المخطط باللغة العربية', 'رقم مميز المخطط التقسيمي', 'نوع المخطط', 'تصحيح قطع المخطط', 'تصحيح قطع الاراضي', 'المراجعة_QC_R1!', 'المرحلة'];
                            //         fields.forEach(field => {
                            //             let label = document.createElement('label');
                            //             label.innerHTML = field + ": ";
                            //             form.appendChild(label);

                            //             let input = document.createElement('input');
                            //             input.type = 'text';
                            //             input.id = field;
                            //             input.value = feature.attributes[field];
                            //             form.appendChild(input);

                            //             let br = document.createElement('br');
                            //             form.appendChild(br);
                            //         });

                            //         // Return the div containing the form
                            //         return div;
                            //     }
                            //  };
                            //-------------------------
                        } else if (
                            layerName === 'PlanCorrectionDB.DBO.Neigh_region'
                        ) {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة الأحياء',
                                content:
                                    '<b>اسم الحي:</b> {اسم الحي}' +
                                    '<br><b>رقم المنطقة:</b> {رقم المنطقة}' +
                                    '<br><b>البلدية:</b> {البلدية}' +
                                    '<b>كود المنطقة:</b> {كود المنطقة}' +
                                    '<b>كود الحي:</b> {كود الحي}' +
                                    '<b>كود البلدية:</b> {كود البلدية}' +
                                    '<b>مساحة الحي:</b> {مساحة الحي}' +
                                    '<b>عدد المخططات:</b> {عدد المخططات}'
                            };
                        } else if (layerName === 'PlanCorrectionDB.DBO.zoon') {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة النطاقات',
                                content:
                                    '<b>الأولوية:</b> {الأولوية}' +
                                    '<br><b>كود النطاق:</b> {كود النطاق}' +
                                    '<br><b>مرحلة العمل بالتصوير الجوي:</b> {مرحلة العمل بالتصوير الجوي}' +
                                    '<b>مخطط افراز:</b> {مخطط افراز}' +
                                    '<b>مخطط معتمد:</b> {مخطط معتمد}' +
                                    '<b>مخطط ابتدائي:</b> {مخطط_ابتدائي}' +
                                    '<b>مخطط خاص:</b> {مخطط_خاص}'
                            };
                        } else if (
                            layerName === 'PlanCorrectionDB.DBO.BELEDIYE_region'
                        ) {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة البلدية',
                                content:
                                    '<b>اسم البلدية:</b> {اسم البلدية} ' +
                                    '<br><b>كود البلدية:</b> {كود البلدية}' +
                                    '<br><b>مساحة البلدية:</b> {مساحة البلدية}'
                            };
                        } else if (
                            layerName ===
                            'PlanCorrectionDB.DBO.MadinahAerialPhotography_zone'
                        ) {
                            feature.popupTemplate = {
                                // autocasts as new PopupTemplate()
                                title: 'طبقة نطاق التصوير الجوي',
                                content:
                                    '<b>الإسم:</b> {NAME} ' +
                                    '<br><b>Sub_BlockI:</b> {Sub_BlockI}' +
                                    '<br><b> AREA_PHOTOGRAPHY:</b> {AREA_PHOTOGRAPHY}'
                            };
                        }
                        return feature;
                    });
                })
                .then((response) => {
                    // Send the array of features to showPopup()
                    this.showPopup(response, event);
                });

            // Shows the results of the identify in a popup once the promise is resolved
            //------------------------------main before test
        }
    }

    //  createForm(feature, layerName) {
    //   // let the=this;
    //   let form = document.createElement('form');
    //   form.id = layerName + 'Form';

    //   // Retrieve labels for the current layer
    //   let inputFields = this.layerLabels[layerName];

    //   for (let i = 0; i < inputFields.length; i++) {
    //      let label = document.createElement('label');
    //      label.htmlFor = layerName + '_' + inputFields[i];
    //      label.innerText = inputFields[i] + ":";
    //      form.appendChild(label);

    //      let input = document.createElement('input');
    //      input.type = 'text';
    //      input.id = layerName + '_' + inputFields[i]; // Append layerName to the input field name
    //      input.name = layerName + '_' + inputFields[i]; // Append layerName to the input field name
    //      form.appendChild(input);

    //   }

    //   // Add submit button
    //   let submitButton = document.createElement('input');
    //   submitButton.type = 'submit';
    //   submitButton.value = 'Submit';
    //   form.appendChild(submitButton);

    //   document.body.appendChild(form);

    //   document.getElementById(layerName + 'Form').addEventListener('submit', function(event) {
    //      event.preventDefault();

    //      // Get form values
    //      let formValues = {};
    //      for (let i = 0; i < inputFields.length; i++) {
    //        formValues[layerName + '_' + inputFields[i]] = (document.getElementById(layerName + '_' + inputFields[i]) as HTMLInputElement).value; // Use the full name including layerName
    //      }

    //      // Update popupTemplate
    //      let content = "";
    //      for (let key in formValues) {
    //        content += `<b>${key}:</b> ${formValues[key]} <br>`;
    //      }
    //      feature.popupTemplate = {
    //        title: layerName,
    //        content: content
    //      };
    //     //  form.remove();

    //     //  // Clear the form
    //     // for (let i = 0; i < inputFields.length; i++) {
    //     //   (document.getElementById(layerName + '_' + inputFields[i]) as HTMLInputElement).value = '';
    //     // }

    //   });
    //  }

    showPopup(response, event) {
        if (response.length > 0) {
            this.mapService.mapView.openPopup({
                features: response,
                location: event.mapPoint
            });
        }
        // document.getElementById("feature.attributes.mapView").style.cursor = "auto";
    }

    poenAndHideOverliyPopup() { }
    // ===========================================
    // Show Overlay Popup
    // ===========================================
    showOverlayPopup: boolean = false;
    poenDetailsPopup() {
        this.showOverlayPopup = !this.showOverlayPopup;
        this.layerPopup.classList.remove('active');
        this.switchBetweenMap.classList.remove('active');
    }

    // ----------------------------------
    switchBetweenMap;
    openSwitchMapPopup() {
        this.switchBetweenMap = document.querySelector(
            '.esri-widget.esri-basemap-toggle.esri-widget'
        ) as HTMLElement;
        this.switchBetweenMap.classList.toggle('active');
        this.showOverlayPopup = false;
        this.layerPopup.classList.remove('active');
    }
    // -----------------------------------
    layerPopup;
    openLayerPopup() {
        this.layerPopup = document.querySelector(
            '.esri-component.esri-layer-list.esri-widget.esri-widget--panel'
        ) as HTMLElement;
        this.layerPopup.classList.toggle('active');
        this.switchBetweenMap?.classList.remove('active');
        this.showOverlayPopup = false;
    }
    // -----------------------------------
    tasalsoliPopup;
    openTasalsoliPopup() {
        this.tasalsoliPopup = document.querySelector(
            '.overlay-taslsoli'
        ) as HTMLElement;
        this.tasalsoliPopup.classList.toggle('active');

        // this.switchBetweenMap.classList.remove("active");
        // this.showOverlayPopup = false;
    }
}
